import Delta from "quill-delta";
import Clipboard from "quill/modules/clipboard";
import { Quill } from "vue2-editor";
import axios from "axios";

export default class CustomClipboardPlugin extends Clipboard {
    constructor(quill) {
        super(quill, {
            matchers: [],
        });
        this.quill = quill;
        
        // Usar MutationObserver en lugar de DOMNodeInserted
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Manejar los cambios aquí si es necesario
                }
            });
        });

        observer.observe(this.quill.root, {
            childList: true,
            subtree: true
        });

        this.quill.root.addEventListener('paste', this.onPaste.bind(this), true);
    }

    onPaste(event) {
        event.preventDefault();
        event.stopPropagation();
        const range = this.quill.getSelection(true);
        if (range === null) return;

        const items = event.clipboardData.items;
        // console.log('Items en portapapeles:', items);
        
        let hasImage = false;
        let imageFile = null;
        let _textHtml = null;

        // Primero intentamos obtener el HTML
        if (event.clipboardData?.getData('text/html')) {
            _textHtml = event.clipboardData?.getData('text/html');
            // console.log('Texto HTML encontrado:', _textHtml);
            
            // Crear un parser temporal para extraer imágenes del HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(_textHtml, 'text/html');
            const images = doc.getElementsByTagName('img');
            
            if (images.length > 0) {
                // console.log('Imágenes encontradas en HTML:', images.length);
                // Convertir las imágenes a formato Delta
                const delta = new Delta()
                    .retain(range.index)
                    .delete(range.length);

                // Procesar cada imagen
                for (let img of images) {
                    const imgUrl = img.src;
                    delta.insert({ image: imgUrl });
                }

                // Agregar el texto restante
                const textContent = doc.body.textContent;
                if (textContent.trim()) {
                    delta.insert(textContent);
                }

                // Aplicar los cambios
                this.quill.updateContents(delta, Quill.sources.USER);
                
                // Mover el cursor al final
                const newPosition = range.index + delta.length();
                this.quill.setSelection(newPosition, 0, Quill.sources.SILENT);
                return;
            }
        }

        // Si no hay imágenes en el HTML, intentar obtener la imagen del portapapeles
        for (let i = 0; i < items.length; i++) {
            // console.log('Tipo de item:', items[i].type);
            if (items[i].type.indexOf('image') !== -1) {
                hasImage = true;
                imageFile = items[i].getAsFile();
                console.log('Imagen encontrada:', imageFile);
                break;
            }
        }

        // Si hay imagen en el portapapeles, procesarla
        if (hasImage && imageFile) {
            // console.log('Procesando imagen del portapapeles...');
            const formData = new FormData();
            formData.append("image", imageFile);

            axios.post("api/protocolo/image", formData)
            .then((result) => {
                console.log('Imagen subida:', result.data.url);
                const url = result.data.url;
                
                const delta = new Delta()
                    .retain(range.index)
                    .delete(range.length)
                    .insert({ image: url });

                if (_textHtml) {
                    const pastedDelta = this.quill.clipboard.convert(_textHtml);
                    delta.concat(pastedDelta);
                }

                this.quill.updateContents(delta, Quill.sources.USER);
                const newPosition = range.index + (delta.length() - range.length);
                this.quill.setSelection(newPosition, 0, Quill.sources.SILENT);
            })
            .catch((err) => {
                // console.error('Error al subir la imagen:', err);
                if (_textHtml) {
                    const pastedDelta = this.quill.clipboard.convert(_textHtml);
                    const delta = new Delta()
                        .retain(range.index)
                        .delete(range.length)
                        .concat(pastedDelta);
                    this.quill.updateContents(delta, Quill.sources.USER);
                    this.quill.setSelection(delta.length() - range.length, 0, Quill.sources.SILENT);
                }
            });
        } 
        // Si solo hay texto
        else if (_textHtml) {
            // console.log('Procesando solo texto');
            const pastedDelta = this.quill.clipboard.convert(_textHtml);
            const delta = new Delta()
                .retain(range.index)
                .delete(range.length)
                .concat(pastedDelta);
            this.quill.updateContents(delta, Quill.sources.USER);
            this.quill.setSelection(delta.length() - range.length, 0, Quill.sources.SILENT);
        }
    }
}